'use strict';

export default function routes($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/daily-report', {
      template: require('./index.pug'),
      authenticate: true
    });
};




// WEBPACK FOOTER //
// ./client/app/dailyReport/dailyReport.routes.ts